export default __webpack_public_path__ + "static/media/logo-4-white.47347f69.svg";